import { render, staticRenderFns } from "./TopupSettingModal.vue?vue&type=template&id=8dd095fa&"
import script from "./TopupSettingModal.vue?vue&type=script&lang=js&"
export * from "./TopupSettingModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports